export default "__VITE_ASSET__Cua$X50l__"